(() => {
  const root = document.querySelector('[data-pr3d-root].pr3d-destination');
  const overlay = document.querySelector('[data-pr3d-overlay]');
  const scroller = overlay?.querySelector('[data-pr3d-scroll]');
  const copy = overlay?.querySelector('.pr3d-copy');

  if (!root || !overlay || !scroller || !copy || root.dataset.pr3dTextMotion === 'v2') return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.dataset.pr3dTextMotion = 'v2';

  const chapters = [
    {
      at: 0,
      eyebrow: 'THE HANUMAN CHALISA GIFT SET',
      titleLines: ['Devotion,', 'beautifully', 'experienced.'],
      body: 'Nurturing Humanity.'
    },
    {
      at: .10 / 1.3,
      eyebrow: 'THOUGHTFULLY PRESENTED',
      titleLines: ['A little box.', 'A world within.'],
      body: 'A moment to pause. A gift to keep.'
    },
    {
      at: .50 / 1.3,
      eyebrow: 'THE HANUMAN CHALISA GIFT SET',
      titleLines: ['Every detail,', 'with meaning.'],
      body: 'One pocket-size hardcover. Two wallet devotional cards. One sticker sheet.'
    },
    {
      at: 1 / 1.3,
      eyebrow: 'SACHITRA EVAM BHAVARTH',
      titleLines: ['Made to hold.', 'Made to keep.'],
      body: 'A hardcover companion for home, temple and travel.'
    },
    {
      at: 1.08 / 1.3,
      eyebrow: 'OPEN TO SOMETHING MEANINGFUL',
      titleLines: ['Read.', 'Understand.', 'Feel.'],
      body: 'Selected pages from the original Hindi edition.'
    },
    {
      at: 1.24 / 1.3,
      eyebrow: 'A DAILY RITUAL. A MEANINGFUL GIFT.',
      titleLines: ['For you.', 'For your people.'],
      body: 'Continue with the Hindi Hanuman Chalisa in the PRADIPATVA store.'
    }
  ];

  // Keep chapter selection aligned with the existing 3D controller.
  const thresholds = chapters.map((chapter, index) => index === 0 ? 0 : Math.max(0, chapter.at - .015));
  const lastChapter = chapters.length - 1;
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const smooth = (value) => {
    const t = clamp(value);
    return t * t * (3 - 2 * t);
  };
  const easeRange = (start, end, value) => {
    if (end <= start) return value >= end ? 1 : 0;
    return smooth((value - start) / (end - start));
  };

  const visual = document.createElement('div');
  visual.className = 'pr3d-copy__visual pr3d-copy__visual--pro';
  visual.setAttribute('aria-hidden', 'true');

  const createLayer = () => {
    const layer = document.createElement('div');
    layer.className = 'pr3d-copy__layer';

    const kicker = document.createElement('div');
    kicker.className = 'pr3d-copy__kicker';

    const accent = document.createElement('span');
    accent.className = 'pr3d-copy__accent';

    const eyebrow = document.createElement('span');
    eyebrow.className = 'pr3d-eyebrow pr3d-copy__motion-eyebrow';
    kicker.append(accent, eyebrow);

    const title = document.createElement('h2');
    title.className = 'pr3d-copy__motion-title';

    const body = document.createElement('p');
    body.className = 'pr3d-copy__motion-body';

    layer.append(kicker, title, body);
    visual.appendChild(layer);

    return { layer, kicker, accent, eyebrow, title, body, lines: [] };
  };

  const layerA = createLayer();
  const layerB = createLayer();
  copy.appendChild(visual);
  copy.classList.add('pr3d-copy--motion');

  const setChapter = (target, index) => {
    if (target.layer.dataset.pr3dMotionChapter === String(index)) return;
    const chapter = chapters[index];
    target.layer.dataset.pr3dMotionChapter = String(index);
    target.eyebrow.textContent = chapter.eyebrow;
    target.body.textContent = chapter.body;
    target.title.replaceChildren();
    target.lines = chapter.titleLines.map((lineText) => {
      const mask = document.createElement('span');
      mask.className = 'pr3d-copy__line-mask';
      const line = document.createElement('span');
      line.className = 'pr3d-copy__line';
      line.textContent = lineText;
      mask.appendChild(line);
      target.title.appendChild(mask);
      return line;
    });
  };

  const rawProgress = () => {
    const max = Math.max(1, scroller.scrollHeight - scroller.clientHeight);
    return clamp(scroller.scrollTop / max);
  };

  const chapterIndexFor = (progress) => {
    let index = 0;
    for (let i = 1; i < thresholds.length; i += 1) {
      if (progress >= thresholds[i]) index = i;
      else break;
    }
    return index;
  };

  const driftFor = (index, progress) => {
    if (index === lastChapter) return 0;
    const start = thresholds[index];
    const end = thresholds[index + 1] ?? 1;
    const local = clamp((progress - start) / Math.max(.0001, end - start));
    return (0.5 - local) * 6;
  };

  const setLayerY = (target, y) => {
    target.layer.style.setProperty('--pr3d-motion-layer-y', `${y.toFixed(2)}px`);
  };

  const setKicker = (target, opacity, y, accentScale) => {
    target.kicker.style.opacity = opacity.toFixed(4);
    target.kicker.style.transform = `translate3d(0,${y.toFixed(2)}px,0)`;
    target.accent.style.transform = `scaleX(${clamp(accentScale).toFixed(4)})`;
  };

  const setBody = (target, opacity, y) => {
    target.body.style.opacity = opacity.toFixed(4);
    target.body.style.transform = `translate3d(0,${y.toFixed(2)}px,0)`;
  };

  const setLine = (line, opacity, yPercent) => {
    line.style.opacity = opacity.toFixed(4);
    line.style.transform = `translate3d(0,${yPercent.toFixed(2)}%,0)`;
  };

  const showStatic = (index, progress) => {
    setChapter(layerA, index);
    layerA.layer.hidden = false;
    layerB.layer.hidden = true;
    layerA.layer.style.zIndex = '2';
    setLayerY(layerA, driftFor(index, progress));
    setKicker(layerA, 1, 0, 1);
    setBody(layerA, 1, 0);
    layerA.lines.forEach((line) => setLine(line, 1, 0));
  };

  const showBlend = (position) => {
    const lower = Math.max(0, Math.min(lastChapter, Math.floor(position)));
    const upper = Math.max(lower, Math.min(lastChapter, lower + 1));
    const t = clamp(position - lower);

    if (lower === upper || t <= .001) {
      showStatic(lower, latestRawProgress);
      return;
    }
    if (t >= .999) {
      showStatic(upper, latestRawProgress);
      return;
    }

    setChapter(layerA, lower);
    setChapter(layerB, upper);
    layerA.layer.hidden = false;
    layerB.layer.hidden = false;
    layerA.layer.style.zIndex = '1';
    layerB.layer.style.zIndex = '2';
    setLayerY(layerA, 0);
    setLayerY(layerB, 0);

    // Outgoing chapter: supporting copy leaves first, title follows, kicker holds longest.
    const outBody = easeRange(.05, .46, t);
    const outKicker = easeRange(.28, .88, t);
    setBody(layerA, 1 - outBody, -7 * outBody);
    setKicker(layerA, 1 - outKicker, -4 * outKicker, 1 - (.36 * outKicker));
    layerA.lines.forEach((line, index) => {
      const outLine = easeRange(.12 + index * .045, .70 + index * .045, t);
      setLine(line, 1 - outLine, -22 * outLine);
    });

    // Incoming chapter: accent/eyebrow first, headline lines reveal through masks, body settles last.
    const finalEntry = upper === lastChapter;
    const kickerIn = easeRange(.02, finalEntry ? .38 : .30, t);
    const bodyIn = easeRange(finalEntry ? .50 : .44, finalEntry ? .96 : .90, t);
    const incomingTravel = finalEntry ? 58 : 105;
    setKicker(layerB, kickerIn, (1 - kickerIn) * (finalEntry ? 3 : 5), .48 + (.52 * kickerIn));
    setBody(layerB, bodyIn, (1 - bodyIn) * (finalEntry ? 5 : 9));
    layerB.lines.forEach((line, index) => {
      const start = (finalEntry ? .12 : .10) + index * (finalEntry ? .085 : .072);
      const end = (finalEntry ? .72 : .62) + index * (finalEntry ? .055 : .052);
      const lineIn = easeRange(start, Math.min(.92, end), t);
      setLine(line, lineIn, incomingTravel * (1 - lineIn));
    });
  };

  let latestRawProgress = rawProgress();
  let targetChapter = chapterIndexFor(latestRawProgress);
  let motionPosition = targetChapter;
  let raf = 0;
  let lastTime = performance.now();

  const render = () => {
    const rounded = Math.round(motionPosition);
    if (Math.abs(motionPosition - rounded) < .001) showStatic(rounded, latestRawProgress);
    else showBlend(motionPosition);
  };

  const tick = (now) => {
    const dt = Math.min(48, Math.max(8, now - lastTime)) / 1000;
    lastTime = now;
    const delta = targetChapter - motionPosition;
    const distance = Math.abs(delta);

    if (distance > .001) {
      const catchingUp = distance > 1.15;
      const tau = catchingUp ? .13 : .20;
      const maxSpeed = catchingUp ? 5.0 : 2.4;
      const exponentialStep = delta * (1 - Math.exp(-dt / tau));
      const maxStep = maxSpeed * dt;
      const step = Math.sign(exponentialStep) * Math.min(Math.abs(exponentialStep), maxStep);
      motionPosition = clamp(motionPosition + step, 0, lastChapter);
      if (Math.abs(targetChapter - motionPosition) < .0015) motionPosition = targetChapter;
    }

    render();

    if (Math.abs(targetChapter - motionPosition) > .001) {
      raf = requestAnimationFrame(tick);
    } else {
      raf = 0;
    }
  };

  const requestTick = () => {
    latestRawProgress = rawProgress();
    targetChapter = chapterIndexFor(latestRawProgress);
    if (!raf) {
      lastTime = performance.now();
      raf = requestAnimationFrame(tick);
    }
  };

  render();
  scroller.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick, { passive: true });
})();
